import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Fanhui2"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 7.5C1.5 7.22386 1.72386 7 2 7H14.4331C14.7093 7 14.9331 7.22386 14.9331 7.5V8.5C14.9331 8.77614 14.7093 9 14.4331 9H2C1.72386 9 1.5 8.77614 1.5 8.5V7.5Z",
  fill: "#2C364E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.99342 3.64648C7.18868 3.84174 7.18868 4.15832 6.99342 4.35358L3.70053 7.64648C3.50527 7.84174 3.50527 8.15832 3.70053 8.35358L6.99342 11.6465C7.18868 11.8417 7.18868 12.1583 6.99342 12.3536L6.28631 13.0607C6.09105 13.256 5.77446 13.256 5.5792 13.0607L0.872107 8.35358C0.676845 8.15832 0.676845 7.84174 0.872107 7.64648L5.5792 2.93937C5.77446 2.74411 6.09105 2.74411 6.28631 2.93937L6.99342 3.64648Z",
  fill: "#2C364E"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var fanhui_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { fanhui_2 as default };
